export default "__VITE_ASSET__D1ncc_cA__"